import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from '../assets/images/logo.png';
import { DropdownArrowLine, DropdownArrowLineClosed } from "../Component/AllSvg";
// import { DropdownArrowLine, DropdownArrowLineClosed } from "../components/AllSvg";

const SidebarDropDown = (props) => {
  let { data, index, currentPath, isexpand } = props;
  currentPath = currentPath.split("/");
  let paths = currentPath[2];

  const [open, setOpen] = useState(data.subMenu?.some(item => item.userId === paths));
  const [hoverOpen, setHoverOpen] = useState(false);

  const handleDocumentClick = (e) => {
    if (e.target.closest(".dashboard-sidebar-middle-menu-split") !== null) return;
    setOpen(false);
  };

  useEffect(() => {
    document.addEventListener("click", handleDocumentClick);
    return () => {
      document.removeEventListener("click", handleDocumentClick);
    };
  }, []);

  return (
    <>
      <div
        className={isexpand ? "dashboard-sidebar-middle-menu-split tooltipp-container" : "dashboard-sidebar-middle-menu-split-closed tooltipp-container"}
        key={index}
        onClick={() => isexpand && setOpen(!open)}
        onMouseEnter={() => !isexpand && setHoverOpen(true)}
        onMouseLeave={() => !isexpand && setHoverOpen(false)}
        style={{ position: "relative" }}
      >
        <div className={isexpand ? "dashboard-sidebar-middle-menu" : "dashboard-sidebar-middle-menu-closed"}>

          {
            data.subMenu.length === 1 ?
              <Link to={`${data.subMenu[0].userId}`}>
                <div
                  dangerouslySetInnerHTML={{
                    __html: data.subMenu?.some(item => item.userId === paths)
                      ? data.svgfill
                      : data.svg
                  }}
                />
              </Link>
              :
              <div
                dangerouslySetInnerHTML={{
                  __html: data.subMenu?.some(item => item.userId === paths)
                    ? data.svgfill
                    : data.svg
                }}
              />
          }
          {isexpand && (
            <h2
              className="sidebarname font-weight400 font-size-heading"
              style={{
                color: data.subMenu?.some(item => item.userId === paths)
                  ? "#2576BC"
                  : "#707070",
                marginLeft: "10px",
                marginTop: "10px"
              }}
            >
              {data.name}
            </h2>
          )}
        </div>

        {isexpand ? (
          open ?
            (
              <DropdownArrowLine color={data.subMenu?.some(item => item.userId === paths) ? "#2576BC" : "#707070"} />
            )
            :
            (
              <DropdownArrowLineClosed color={data.subMenu?.some(item => item.userId === paths) ? "#2576BC" : "#707070"} />
            )
        )
          : ""}
        {!isexpand ?
          hoverOpen &&
          (
            <div className="sidebarpopup" style={{
              position: "absolute",
              top: 0,
              left: "100%",
              background: "#fff",
              boxShadow: "0 0 10px rgba(0,0,0,0.1)",
              borderRadius: "6px",
              padding: "8px",
              zIndex: 10,
              width: "200px"
            }}>
              {data.subMenu.length === 0 &&
                <h2
                  className="sidebarname font-weight400 font-size-heading"
                  style={{
                    color: data.subMenu.some((f) => f.userId === paths) ? "#2576BC" : "#707070",
                    // paddingBottom: "6px",
                    cursor: 'not-allowed'
                  }}
                >
                  No Management Authority
                </h2>}
              {data.subMenu.length > 1 &&
                <h2
                  className="sidebarname font-weight400 font-size-heading"
                  style={{
                    color: data.subMenu.some((f) => f.userId === paths) ? "#2576BC" : "#707070",
                    paddingBottom: "6px",
                    borderBottom: "1px solid #eee"
                  }}
                >
                  {data.name}
                </h2>}
              {data.subMenu.map((e, subIndex) => (
                <Link
                  to={`${e.userId}`}
                  className="dashboard-sidebar-middle-menu-sublist  tooltipp-container"
                  key={subIndex}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "6px 0",
                    color: e.userId === paths ? "#2576BC" : "#707070",
                    textDecoration: "none",
                    gap: "8px"
                  }}
                >
                  <div
                    dangerouslySetInnerHTML={{ __html: e.userId === paths ? e.svgfill : e.svg }}
                    style={{ width: "20px", height: "20px" }}
                  />
                  <hr />
                  <div className="font-size-subheading heading">
                    {e.name}
                  </div>
                </Link>
              ))}
            </div>
          )
          : null}
      </div>
      {isexpand && open ? (
        <div>
          {data.subMenu.map((e, index) => {
            return (
              <Link
                to={`${e.userId}`}
                className="dashboard-sidebar-middle-menu-sublist tooltipp-container"
                key={index}
                style={{
                  color: e.userId === paths ? "#2576BC" : "#707070",
                }}
              >
                <DropdownArrowLineClosed color={e.userId === paths ? "#2576BC" : "#707070"} />
                <div
                  dangerouslySetInnerHTML={{ __html: e.userId === paths ? e.svgfill : e.svg }}
                  style={{ width: "20px", height: "20px" }}
                />
                <h3
                  style={{
                    marginLeft: "10px",
                    marginTop: "10px"
                  }}
                  className=" font-size-subheading  heading">
                  {e.name}
                </h3>
              </Link>
            );
          })}
        </div>
      ) : null}
    </>
  );
};

const SidebarLink = (props) => {
  const { data, index, currentPath, isexpand } = props;
  let paths = currentPath.split("/");
  paths = paths[2];
  return (
    <Link
      to={`${data.userId}`}
      className={`${isexpand ? 'justify-start' : 'justify-center'} dashboard-sidebar-middle-menu-closed tooltipp-container`}
      key={index}
    >
      <div className="tooltippp" dangerouslySetInnerHTML={{ __html: data.userId === paths ? data.svgfill : data.svg }} />
      {!isexpand &&
        <div className="tooltipp"
          style={{
            color: data.userId === paths ? "#2576BC" : "#707070",
          }}
        >
          {data.name}
        </div>
      }
      {isexpand &&
        <h2
          className="sidebarname font-weight400 font-size-heading"
          style={{
            color: data.userId === paths ? "#2576BC" : "#707070",
            marginLeft: "10px",
            marginTop: "10px"
          }}
        >
          {data.name}
        </h2>}
    </Link >
  );
};





const DashboardSidebar = (props) => {
  const { sidebarData, isexpand, setExpanded } = props;
  const [currentPath, setCurrentPath] = useState(window.location.pathname);
  const location = useLocation();

  useEffect(() => {
    setCurrentPath(window.location.pathname);
  }, [location]);

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setExpanded(!isexpand)
  };

  const dprRole = sessionStorage.getItem("dpr_role") || "super_admin";

  const rolePrefix = {
    super_admin: "super_admin",
    admin: "admin",
    hod: "hod",
    engineer: "ed",
    viewer: "viewer",
  };

  const dashboardPath = `/${rolePrefix[dprRole] || "super_admin"}/projectportfolio`;


  return (
    <div className={isexpand ? "dashboard-main-sidebar-section" : "dashboard-main-sidebar-section-closed"}>
      {/* <div className="fixed-nav"> */}
      <div className="">
        <Link to={dashboardPath}>
          <img className="sidebar-closed-logo-cipl" src={logo} alt="logo" />
        </Link>

        <div className="sidebar-title   font-weight400  font-size-subheading">
          {/* <button className="sidebar-title" onClick={handleFormSubmit}> */}
          Menu
          {/* </button> */}
        </div>
        <div className="fixed-sidebar">
          <div className="scrollable-content">
            {sidebarData.map((data, index) => {
              return data.subMenu ? (
                <SidebarDropDown
                  data={data}
                  currentPath={currentPath}
                  index={index}
                  isexpand={isexpand}
                />
              ) : (
                <SidebarLink
                  data={data}
                  currentPath={currentPath}
                  index={index}
                  isexpand={isexpand}
                  key={index}
                />
              );
            })}
          </div>
        </div>

      </div>
    </div>
  );
};



export default DashboardSidebar